import AmenityIconRenderer from "./AmenityIconRenderer";
import type { Amenity } from "@/types/Amenity";

type AmenitiesRendererProps = {
  amenities: Amenity[];
  hideLabels?: boolean;
  showCount?: boolean;
};

const AmenitiesRenderer = ({ amenities, hideLabels, showCount }: AmenitiesRendererProps) => {
  return (
    <>
      {amenities.map((amenity) => (
        <div key={amenity.id} className="flex flex-row bg-gray-200 p-1 rounded-md items-center pl-1.5 mr-1">
          {showCount && amenity.count ? <span className="text-base text-gray-700">{amenity.count}×</span> : null}
          <AmenityIconRenderer key={amenity.id} amenity={amenity} hideLabel={hideLabels} />
        </div>
      ))}
    </>
  );
};

export default AmenitiesRenderer;
